import * as yup from 'yup';

const IMPORT_RESOURCES_FROM_CSV_VALIDATION_SCHEMA = yup.object().shape({
  csvFile: yup.mixed().required('File is required'),
});

export default IMPORT_RESOURCES_FROM_CSV_VALIDATION_SCHEMA;
